import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { IconThumbDown, IconThumbUp } from '@tabler/icons-react';
import TimeAgo from "@/hooks/timesAge";

export default function ThredMessage({message}){


    return(
        <> 
        <div className="flex flex-col w-full m-4 ">
           
            {/* <div className="flex flex-row justify-between ">
            <span className=""><span className="font-bold">Agent </span>provided an update:</span>
            <span className="text-muted-foreground">6 hours ago</span>
            </div> */}
            <div className="text-muted-foreground border rounded-md p-2 rounded-b-none bg-zinc-50">
                <div className="flex flex-row justify-between ">
                <span className="text-xs">Triggered by Nursid Ansari:</span>
                <span className="text-muted-foreground text-xs">{TimeAgo(message.timestamp)}</span>
            </div>
            <div className="text-lg font-bold text-black">Greeting</div>
            </div>
            <Card className="w-full p-4 rounded-t-none">
                <span className="flex flex-col items-left justify-center h-full text-lg  text-justify text-muted-foreground">
                {message.text}
                </span>
            </Card>
            {/* <div className="flex justify-end mt-1">

            <Button size="xs" variant="outline" className="border-none bg-zinc-50 hover:bg-gray-100 text-muted-foreground"> <IconThumbUp size={16} className="me-2 mt-1"/> Good</Button>

                <Button size="xs" variant="outline" className="border-none bg-zinc-50 hover:bg-gray-100 text-muted-foreground"> <IconThumbDown size={16} className="me-2 mt-1"/> Bad</Button>
            </div> */}
        </div>
       
        </>
    )

}